export default function Footer() {
  const year = new Date().getFullYear()

  return (
    <footer
      className="mt-20"
      style={{
        borderTop: '1px solid var(--border)',
        paddingBottom: 'env(safe-area-inset-bottom, 0px)',
        background: 'var(--surface)',
      }}
    >
      <div className="max-w-[1200px] mx-auto px-5 py-4 flex flex-wrap items-center justify-between gap-2">
        <span className="font-mono text-[11px] font-bold tracking-[0.12em]" style={{ color: 'var(--accent)' }}>
          MARKETINTEL · {year}
        </span>
        <span className="font-mono text-[10px]" style={{ color: 'var(--text-3)' }}>
          Kein Anlageberatung — persönliches Analysewerkzeug, Informationen ohne Gewähr
        </span>
      </div>
    </footer>
  )
}
